<template>
  <b-modal ref="modal" id="modal-tutorial" :title="computedTitle">
    <span class="close" @click="onClose">
      <x-icon size="1.25x"></x-icon>
    </span>
    <slot></slot>
  </b-modal>
</template>

<script>
import { CheckIcon, XIcon } from "vue-feather-icons";
import tt from "@/lib/trim-text.js";
export default {
  components: {
    XIcon,
    CheckIcon,
  },
  data: function () {
    var obj = {
      slide: 0,
      sliding: null,
      lock: false,
      bucket: {
        title: "",
        color: 2,
      },
    };
    return obj;
  },
  props: ["title"],
  computed: {
    computedTitle: function () {
      return this.title || "Tutorial";
    },
  },
  methods: {
    onClose: function () {
      this.$refs.modal.hide();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    hide: function () {
      this.$refs.modal.hide();
    },
    show: function () {
      this.$refs.modal.show();
    },
  },
};
</script>

<style lang="scss">
#modal-tutorial___BV_modal_outer_ {
  .modal-dialog {
    max-width: 720px;
  }
  .footer {
    display: flex;
    justify-content: space-between;
  }
  .carousel {
    margin-bottom: 32px;
    background-color: transparent !important;
  }
  .carousel-item {
    background-color: transparent !important;
    opacity: 0;
    transition: all 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
    border-radius: 12px;
    overflow: hidden;
    &.active {
      opacity: 1;
    }
    &.text {
      .carousel-caption {
        position: static;
      }
    }
  }
  .carousel-indicators {
    bottom: -32px;
    li {
      margin: 0 8px;
      width: 12px;
      height: 12px;
      background-color: var(--s1);
      opacity: 0.5;
      transition: opacity 250ms ease;
      border-radius: 50%;
      border: none;

      &:focus {
        opacity: 1;
        outline: none;
        box-shadow: none;
      }

      &.active {
        opacity: 1;
      }
    }
  }
}
</style>
